
import './App.css';



import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/main.scss';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { OpeningHoursProvider } from './contexts/OpeningHoursContext';

import HomePage from './components/pages/HomePage';
import Login from './components/Login';
import Narozeniny from './components/pages/Narozeniny';

import ChangePassword from './components/ChangePassword';
import FotoGalerie from './components/pages/FotoGalerie';
import Novinky from './components/pages/Novinky';
import Kavarna from './components/pages/Kavarna';
import Cenik from './components/pages/Cenik';
import NotFound from './components/pages/NotFound';
import Kontakt from './components/pages/Kontakt';

function App() {
    return (
        <Router>
            <OpeningHoursProvider>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/changePassword" element={<ChangePassword />} />
                        <Route path="/narozeniny" element={<Narozeniny />} />
                        <Route path="/novinky" element={<Novinky />} />
                        <Route path="/kavarna" element={<Kavarna />} />
                        <Route path="/fotoGalerie" element={<FotoGalerie />} />
                        <Route path="/cenik" element={<Cenik />} />
                        <Route path="/kontakt" element={<Kontakt />} />
                        <Route path="/" element={<HomePage />} />

                        <Route path="*" element={<NotFound />} /> {/* Nově přidaná cesta pro 404 */}

                    </Routes>
                </AuthProvider>
            </OpeningHoursProvider>
        </Router>
    );
}

export default App;

